"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var classnames_1 = require("classnames");
var React = require("react");
var tombacIcon = function (name) {
    var nameWords = name.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g);
    var kebabCasedName = nameWords
        ? nameWords.join('-').toLowerCase()
        : name.toLowerCase();
    return function (SvgIcon) {
        var TombacIcon = function (_a) {
            var className = _a.className, _b = _a.fixedWidth, fixedWidth = _b === void 0 ? true : _b, _c = _a.flip, flip = _c === void 0 ? false : _c, _d = _a.rotate, rotate = _d === void 0 ? 0 : _d, _e = _a.size, size = _e === void 0 ? 1 : _e, _f = _a.spin, spin = _f === void 0 ? false : _f, rest = tslib_1.__rest(_a, ["className", "fixedWidth", "flip", "rotate", "size", "spin"]);
            return (React.createElement(SvgIcon, tslib_1.__assign({ className: classnames_1.default('TombacIcon', "TombacIcon--" + kebabCasedName, fixedWidth && 'TombacIcon--fixed-width', flip && "TombacIcon--flip-" + flip, rotate !== 0 && "TombacIcon--rotate-" + rotate, size !== 1 &&
                    "TombacIcon--" + (typeof size === 'string' ? size : size + 'x'), spin && "TombacIcon--spin", className) }, rest)));
        };
        TombacIcon.displayName = name + "Icon";
        return TombacIcon;
    };
};
exports.default = tombacIcon;
//# sourceMappingURL=tombacIcon.js.map